import React, { useState, useEffect } from "react";
import { Row, Col, Button, Container, Tabs, Tab } from "react-bootstrap";
import SearchableSelect from "../../Components/SearchableSelect";
import SearchInput from "../../Components/SearchInput";
import moment from "moment/moment";
import DatePicker from "../../Components/DatePicker/DatePicker";
import { Link } from "react-router-dom";
import { FiBell, FiSend, FiMessageSquare } from "react-icons/fi";
import style from "../../styles/Notification.module.css";
import "../../Components/NotificationDropdown/Notifications.css";
import "../../Components/SalesAndDeals/SalesAndDeals.css";
import AllNotifications from "./AllNotifications";
import SMS from "./SMS";
function NotificationsTable() {
  const [noOfPages, setNoOfPages] = useState(1);
  const [sizeOfPages, setSizeOfPages] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [count, setCount] = useState(0);
  const [toggle, refresh] = useState(false);

  const [searchInput, setSearchInput] = useState("");
  const [fromDate, setFromDate] = useState(moment().subtract(100, "years")._d);
  const [toDate, setToDate] = useState(moment().add(100, "years")._d);
  const [currentTab, setCurrentTab] = useState("SMS");
  const searchFilter = (e) => {
    e.preventDefault();
    if (e.target.value === "") {
      setSearchInput("");
    } else {
      setSearchInput(e.target.value);
    }
  };
  const resetFilterHandle = () => {
    setSearchInput("");
    setSizeOfPages(10);
    setFromDate(moment().subtract(100, "years")._d);
    setToDate(moment().add(100, "years")._d);
  };

  const handlePageSize = (e) => {
    setSizeOfPages(e.value);
  };

  const changePage = (page) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    if (currentPage === 1) {
      refresh((prev) => !prev);
    } else {
      changePage(1);
    }
  }, []);
  const handleTabs = (e) => {
    setCurrentTab(e);
    setSearchInput("");
    setSizeOfPages(10);
    setFromDate(moment().subtract(100, "years")._d);
    setToDate(moment().add(100, "years")._d);
  };

  return (
    <Container fluid>
      <div className="notif-page-header">
        <div className="notif-page-identity">
          <span className="notif-page-icon">
            <FiBell />
          </span>
          <div>
            <h1 className="notif-page-title">Notification Center</h1>
            <span className="notif-page-subtitle">Send and track SMS and push notifications</span>
          </div>
        </div>
        <div className="d-flex gap-2">
          <Link to="/notification-center/send" state={{ type: "notify" }} className="sd-btn-toggle sd-btn-create" style={{ textDecoration: "none" }}>
            <FiSend size={14} /> Send Notification
          </Link>
          <Link to="/notification-center/send" state={{ type: "sms" }} className="sd-btn-toggle sd-btn-create" style={{ textDecoration: "none" }}>
            <FiMessageSquare size={14} /> Send SMS
          </Link>
        </div>
      </div>

      <div className="bg-white p-4 border-0 rounded-3 shadow-sm">
        <Row className="d-flex align-items-center">
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <SearchInput searchlogo handleChange={searchFilter} value={searchInput} />
          </Col>
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3"></Col>
          <Col xs lg="3" xl="2" className="d-none d-lg-inline mb-3">
            <DatePicker important={true} fromDate={fromDate} toDate={toDate} setFromDate={setFromDate} setToDate={setToDate} />
          </Col>
          <Col xs="6" lg="3" xl="2" sm="3" className="mb-3">
            <SearchableSelect
              selectClassName={"bg-white"}
              placeholder={`Showing ${sizeOfPages}`}
              defaultValue={`Showing ${sizeOfPages}`}
              value={`Showing ${sizeOfPages}`}
              searchable={false}
              options={[
                { value: "10", label: "10" },
                { value: "20", label: "20" },
                { value: "30", label: "30" },
              ]}
              handleChange={handlePageSize}
            />
          </Col>
        </Row>
        <div className="pt-2">
          <Button size="sm" type="submit" style={{ fontSize: "14px" }} onClick={resetFilterHandle}>
            <span className="d-lg-inline">Reset Filters</span>{" "}
          </Button>
        </div>
        <Row style={{ marginBottom: "-3rem" }} className="mt-3">
          <Col>
            <Tabs defaultActiveKey="SMS" className={`${style.navtabs} notif-tabs`} onSelect={handleTabs}>
              <Tab eventKey="SMS" title="SMS" className="text-secondary mb-5">
                <SMS sizeOfPages={sizeOfPages} currentPage={currentPage} setCurrentPage={setCurrentPage} searchInput={searchInput} fromDate={fromDate} toDate={toDate} currentTab={currentTab} />
              </Tab>
              <Tab eventKey="Notifications" title="Notifications" className="text-secondary mb-5">
                <AllNotifications sizeOfPages={sizeOfPages} currentPage={currentPage} setCurrentPage={setCurrentPage} searchInput={searchInput} fromDate={fromDate} toDate={toDate} currentTab={currentTab} />
              </Tab>
            </Tabs>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default NotificationsTable;
